import { Controller, useForm } from "react-hook-form";
import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, MenuItem, TextField, InputAdornment } from "@material-ui/core";
import { basic, validationMessages, requiredOnly } from '../../../config/validations';
import CreateCancel from "../../atoms/buttons/CreateCancel";
import { createSensor } from '../../../services/entities/sensor';
import { findRelativePosition } from '../../../services/reactFlowService';
import { internalSystem, blueprintWidth } from "../../../config/common";
import { createDelegate } from '../../../services/entities/delegate';
import {IconSelector} from "../../atoms/IconSelectorV2";
import { invokePostService } from '../../../store/global/actions';
import { invokeGetService } from '../../../store/global/actions'
import { findIconSource, generateIconFileName, validateNonAsciiChars } from "../../../utils/commonUtils";

export const CreateDigitalTwinForm = (props) => {
    const { onClose, onCompletion, clusterletDetails, addProfile } = props;
    const { register, handleSubmit, formState: { errors }, setError, control, watch } = useForm();

    const nameValue = watch("name");

    const dispatch = useDispatch();
    const [showDelegateInfo, setShowDelegateInfo] = useState('');
    const [icon, setIcon] = useState(null);
    const [noIcon, setNoIcon] = useState('');
    const [loading, setLoading] = useState(false);
    const [clusterlets, setClusterlets] = useState([]);
    const [delegateTypes, setDelegateTypes] = useState([]);
    const [isFetching, setIsFetching] = useState(false);

    let delegates = clusterlets.filter(ele => ele.type === 1);

    useEffect(() => {
        setIsFetching(true);
        Promise.all([dispatch(invokeGetService('getDelegateProtocols', [])),
        dispatch(invokeGetService('getClusterlets', {}))]).then(([protocolResponse, clusterletResponse]) => {
            if (clusterletResponse?.status) setClusterlets(clusterletResponse.data);
            if (protocolResponse.status && protocolResponse.data) {
                const modifiedDelegateTypes = protocolResponse.data.map(item => ({label: item.schemaJson?.desc, value: item.node}));
                setDelegateTypes(modifiedDelegateTypes);
            }
            setIsFetching(false);
        });
	}, [])



    const messages = {
        ...validationMessages,
    };


    const onCreate = async ({ name, description, ...rest }) => {
        clusterletDetails.name = name;
        clusterletDetails.attributes.desc = description;

        if (icon == null) {
            setNoIcon('Please select an icon')
            return false
        }

        clusterletDetails.icon = generateIconFileName(icon);
        clusterletDetails.iconSource = findIconSource(icon);
        clusterletDetails.includeInViewMetaJson = true;
    
        setLoading(true);
        let direction = 'left'
        const leftBorder = internalSystem.position.x
        const rightBorder = (internalSystem.position.x + internalSystem.style.width);
        const absoluteRightBorderDifference = Math.abs((clusterletDetails.position.x + internalSystem.position.x) - rightBorder)
        const absoluteLeftBorderDifference = Math.abs((clusterletDetails.position.x + internalSystem.position.x) - leftBorder)
        const rightBorderRelativePos = (rightBorder / blueprintWidth) * 100;  // right border relative poition
        if(absoluteLeftBorderDifference > absoluteRightBorderDifference) direction = 'right'

        // Clusterlet
        const clusterlet = JSON.parse(JSON.stringify(clusterletDetails))
        clusterlet.position = findRelativePosition(clusterlet.position, clusterlet.type);
        
        // clusterletDetails containing absolute position and clusterlet containing relative position


        // Delegate
        let delegate = {};
        if (rest?.delegate != 'create') {
            delegate = {_id: rest?.delegate};
            const delegateData = clusterlets.find(ele => ele._id == rest?.delegate);
            direction = delegateData?.position?.x < (rightBorderRelativePos / 2) ? 'left' : 'right';  
        } else {
            delegate = createDelegate(`${name}_GW`, `${name} Gateway`, rest.type, rest.network, direction, delegates, clusterletDetails.position.y); 
            delegate.position = findRelativePosition(delegate.position, delegate.type);   
        }

         // Sensor
         let adjustedPosition = { x: internalSystem.position - 40, y: clusterletDetails.position.y + internalSystem.position.y };
         if(direction === 'right') adjustedPosition = { x: internalSystem.position.x + internalSystem.style.width + 90 , y : clusterletDetails.position.y + internalSystem.position.y }      
         
         const sensor = createSensor(name, `${name} sensor`, adjustedPosition, icon);
         sensor.position = findRelativePosition(sensor.position, sensor.type);

        dispatch(invokePostService('createDigitalTwin', {clusterlet: clusterlet, direction, delegate, sensor })).then(res => {
            setLoading(false);
            if (res?.status) {
                onCompletion(true);
            }else {
                if (res?.code === "600") {
                    res?.errors?.forEach(error => {
                        setError(error.name, {message: error.message});
                    });
                }
            }
        })

    }

    // To remove the icon not selected warning, once the icon is selected
    useEffect(() => {
        if(icon){
            setNoIcon("");
        }
    }, [icon])


    return (
        <Grid id={"create_digitaltwin_form"} container direction={"row"} spacing={3}>
            <Grid item xs={12}>
                <TextField
                    name="name"
                    autoFocus
                    fullWidth
                    type={"text"}
                    required={true}
                    label={"Name"}
                    placeholder={""}
                    variant="outlined"
                    inputRef={register({ ...basic })}
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? errors?.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    id="description"
                    type={"text"}
                    fullWidth
                    multiline={true}
                    rows={4}
                    label={"Description"}
                    placeholder={"Description"}
                    variant="outlined"
                    name="description"
                    inputRef={register({ required: false, validate: validateNonAsciiChars})}
                    error={errors?.description}
                    helperText={errors?.description?.message || ''}
                />
            </Grid>

            {/* Create or choose an existing delegate */}
            <Grid item xs={12} style={{ zIdex: 2000 }}>
                <Controller
                    name="delegate"
                    control={control}
                    rules={{ required: true, requiredOnly }}
                    defaultValue={''}
                    render={({ field, onChange }) =>
                        <TextField
                            {...field}
                            label={'Associate a Delegate'}
                            name="delegate"
                            required
                            select
                            fullWidth
                            variant={'outlined'}
                            onChange={e => { onChange(e); setShowDelegateInfo(e.target.value) }}
                            error={errors?.delegate ? true : false}
                            helperText={messages[errors?.delegate?.type] || ''}
                        >
                            <MenuItem key={'123'} value={''}>Associate a delegate</MenuItem>
                            <MenuItem key={'create'} value={'create'}>Create a delegate</MenuItem>
                            {clusterlets.filter(c => c.type == 1).filter(c => !c.subType).map(c => <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>)}
                        </TextField>
                    }
                />

            </Grid>

            {showDelegateInfo == 'create' &&

                <>

                    <Grid item xs={12} style={{ zIdex: 2000 }}>
                        <Controller
                            name="type"
                            control={control}
                            rules={{ required: true, requiredOnly }}
                            render={({ field, onChange }) =>
                                <TextField
                                    {...field}
                                    label={'Type'}
                                    name="type"
                                    select
                                    fullWidth
                                    required
                                    variant={'outlined'}
                                    onChange={onChange}
                                    error={errors?.type ? true : false}
                                    helperText={messages[errors?.type?.type] || ''}
                                    SelectProps={{
                                        MenuProps: {
                                          MenuListProps: {
                                            id: "type-menu-list", 
                                          },
                                        },
                                      }}
                                    InputProps={{
                                        startAdornment: isFetching ? (
                                          <InputAdornment position="start" style={{width: "100%"}}>
                                            Loading types, please wait..
                                          </InputAdornment>
                                        ) : null,
                                      }}
                                >
                                    <MenuItem key={123} value={""}>Select type</MenuItem>
                                    {delegateTypes.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            }
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            name="network"
                            autoFocus
                            fullWidth
                            type={"text"}
                            required={true}
                            label={"Network"}
                            placeholder={""}
                            variant="outlined"
                            inputRef={register({ ...basic })}
                            error={errors?.network ? true : false}
                            helperText={errors?.network ? messages[errors?.network?.type] : ''}
                        />
                    </Grid>


                </>

            }


            <Grid item xs={12} >
                <IconSelector setSelectedIcon={setIcon} selectedIcon={icon} defaultSearchTag={nameValue}/>
            </Grid>

            {noIcon != '' && 
            <Grid id={"no_icon_selected"} item xs={12} style={{ color: 'red', marginTop: '-5px' }}>
                <p style={{font: "inherit"}}>{noIcon}</p>
            </Grid>}

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end"}}>
                <CreateCancel createDisable={loading} content={loading ? 'Creating..' : 'Create'} onCreate={handleSubmit(onCreate)} onCancel={onClose} />
            </Grid>
        </Grid>
    );

}